var _tspan;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHomeOutlineSix = function SvgHomeOutlineSix(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79,
    height: 152
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "home-outline-six_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 29499",
    transform: "translate(28 373)",
    style: {
      fill: "none"
    },
    d: "M0 0h79v152H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 347",
    transform: "translate(-28 -373)",
    style: {
      clipPath: "url(#home-outline-six_svg__a)"
    }
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": 6,
    transform: "translate(28 497)",
    style: {
      stroke: "#3f54d9",
      strokeWidth: 3,
      fontSize: 140,
      fontFamily: "Sarabun-Bold,Sarabun",
      fontWeight: 700,
      letterSpacing: "-.1em",
      fill: "none"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "6")))));
};

export default SvgHomeOutlineSix;